import {
  getGastronomicMenu,
  getProductCategory,
  getProductName,
  getProductSubcategory,
  isProductActive,
} from "./productAdapter";
import { getProductImage } from "./productMedia";

export function normalizeMenuGroupLabel(value, fallback) {
  const label = String(value || "").trim();
  return label || fallback;
}

export function gastronomicGroupAnchor(value) {
  return `carta-${String(value || "carta")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")}`;
}

export function sortGastronomicMenuItems(left, right) {
  const leftMenu = getGastronomicMenu(left);
  const rightMenu = getGastronomicMenu(right);
  return (
    leftMenu.sectionOrder - rightMenu.sectionOrder
    || leftMenu.sortOrder - rightMenu.sortOrder
    || getProductName(left).localeCompare(getProductName(right), "es")
  );
}

export function gastronomicMenuItems(items = []) {
  return (Array.isArray(items) ? items : [])
    .filter(isProductActive)
    .filter((item) => getGastronomicMenu(item).enabled)
    .sort(sortGastronomicMenuItems);
}

export function featuredGastronomicMenuItems(items = []) {
  const menuItems = gastronomicMenuItems(items);
  const featured = menuItems.filter((item) => getGastronomicMenu(item).featured);
  return featured.length ? featured : menuItems;
}

export function buildGastronomicMenuGroups(items = []) {
  const categoryMap = new Map();
  gastronomicMenuItems(items).forEach((item) => {
    const category = normalizeMenuGroupLabel(getProductCategory(item), "Carta");
    const subcategory = normalizeMenuGroupLabel(getProductSubcategory(item), "Otros");
    const menu = getGastronomicMenu(item);
    if (!categoryMap.has(category)) {
      categoryMap.set(category, { label: category, order: menu.sectionOrder, subcategories: new Map(), products: [] });
    }
    const entry = categoryMap.get(category);
    entry.order = Math.min(entry.order, menu.sectionOrder);
    entry.products.push(item);
    if (!entry.subcategories.has(subcategory)) entry.subcategories.set(subcategory, []);
    entry.subcategories.get(subcategory).push(item);
  });

  return [...categoryMap.values()]
    .map((category) => ({
      label: category.label,
      title: category.label,
      value: category.label,
      slug: gastronomicGroupAnchor(category.label),
      anchor: gastronomicGroupAnchor(category.label),
      order: category.order,
      count: category.products.length,
      image: category.products.map(getProductImage).find(Boolean) || "",
      products: category.products.sort(sortGastronomicMenuItems),
      subcategories: [...category.subcategories.entries()]
        .map(([label, products]) => ({ label, products: products.sort(sortGastronomicMenuItems) }))
        .sort((left, right) => {
          if (left.label === "Otros") return 1;
          if (right.label === "Otros") return -1;
          return left.label.localeCompare(right.label, "es");
        }),
    }))
    .sort((left, right) => left.order - right.order || left.label.localeCompare(right.label, "es"));
}
